import { setContext } from '@apollo/client/link/context'
import { from, ApolloLink } from '@apollo/client'
import { createHttpLink } from '@apollo/client'
import { RetryLink } from '@apollo/client/link/retry'
import { BACKEND_URL } from '@/config/constants'

export const authLink = () =>
  setContext((_, { headers }) => {
    const token = localStorage.getItem('SAFE_v2__Token')

    return {
      headers: {
        ...headers,
        Authorization: token ? `Bearer ${token}` : '',
      },
    }
  })

export const loggerLink = new ApolloLink((operation, forward) => {
  operation.setContext({ start: new Date() })
  return forward(operation).map((response) => {
    return response
  })
})

export const httpLink = () =>
  createHttpLink({
    uri: `${BACKEND_URL}/graphql`,
  })

interface GraphQLError {
  statusCode?: number
  graphQLErrors?: { extensions?: { code?: string } }[]
}

const retryIf = (error: GraphQLError) => {
  if (error.statusCode) {
    const doNotRetryCodes = [400, 401, 403, 500]
    return !doNotRetryCodes.includes(error.statusCode)
  }

  if (error.graphQLErrors) {
    for (const graphQLError of error.graphQLErrors) {
      if (graphQLError.extensions?.code === 'UNAUTHENTICATED' || graphQLError.extensions?.code === 'BAD_USER_INPUT') {
        return false
      }
    }
  }
  return true
}

export const retryLink = new RetryLink({
  delay: {
    initial: 100,
    max: 2000,
    jitter: true,
  },
  attempts: {
    max: 5,
    retryIf,
  },
})

export const links = from([authLink(), httpLink()])
